import { parseAsIsoDate, parseAsStringLiteral, useQueryStates } from 'nuqs';
import { SUMMARY_HORIZONS, type SummaryFilters, type SummaryHorizon } from '../types/Summary';
import { toApiDate } from '../utils/data';

const PARSERS = {
  date: parseAsIsoDate,
  horizon: parseAsStringLiteral(SUMMARY_HORIZONS).withDefault('8'),
};

export function useSummaryFilters() {
  const [state, setState] = useQueryStates(PARSERS, { throttleMs: 300 });

  const filters: SummaryFilters = {
    date: toApiDate(state.date) ?? undefined,
    weeks: Number(state.horizon),
  };

  return {
    filters,
    date: state.date,
    horizon: state.horizon,
    setDate: (date: Date | null) => setState({ date }),
    setHorizon: (horizon: SummaryHorizon) => setState({ horizon }),
  };
}

export type SummaryFilterState = ReturnType<typeof useSummaryFilters>;
